import React, { useRef, useState, useEffect } from 'react';
import styles from './Brands.module.css';
import Scroll from './Scroll/Scroll';
import axios from 'axios';
import { useLocation } from "react-router-dom";

export type BrandsProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>;
}

export type Categories = {
    ID: number;
    Name: string;
    Image: string;
}

const Brands = (props: BrandsProps) => {

    const [categories, setCategories] = useState<Categories[]>([]);
    const [loading, setLoading] = useState(true);
    const loadedScrolls = useRef(0);
    const location = useLocation();

    const handleScrollLoaded = () => {
        loadedScrolls.current += 1;
        if (loadedScrolls.current === categories.length) {
            setLoading(false);
        }
    };

    useEffect(() => {
        props.setNavBackground(true);

        const fetchAll = async () => {
            try {
                const [categories] = await Promise.all([
                    axios.get('https://sazuli.pt/api/getAllBrands'),
                ]);
                setCategories(categories.data);

            } catch (err) {
                console.log(err);
            }
        }
        fetchAll();
    }, []);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const brandName = query.get("brandName");
        if (!brandName) return;

        const scrollToEl = () => {
            const el = document.getElementById(brandName);
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY;
                const offset = 120;
                const target = y - offset;

                requestAnimationFrame(() => {
                    window.scrollTo({ top: target, behavior: "smooth" });
                });

                return true;
            }
            return false;
        };

        if (!scrollToEl()) {
            const interval = setInterval(() => {
                if (scrollToEl()) clearInterval(interval);
            }, 100);
            return () => clearInterval(interval);
        }
    }, [location.search, categories]); // keep categories here


    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Marcas que representamos</h2>

            <div className={styles.items}>
                {categories.map((item, index) => (
                    <div key={index} id={item.ID.toString()}> {/* add id for scroll target */}
                        <Scroll categorie={item} onLoad={handleScrollLoaded} loading={loading} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Brands;
